export const permissionQueryKeys = {
    me: (scenarioId: string) => ['scenario-permissions', scenarioId],
} as const;
